<template>
  <modal-before-container>
    <modal-default
      ref="NotificationsModal"
      title="Notification Center"
      class="notifications_modal"
      on-close-clear-query
      is-wide
      @close="modalClosed"
    >
      <b-tabs
        v-if="isLoaded"
        v-model="currentTab"
        class="tabs_vertical_modal"
        vertical
        expanded
        :animated="false"
      >
        <!-- Mentions -->
        <b-tab-item :value="ENUMS.NotificationCategoryEnum.Mentions.value.toString()">
          <template #header>
            <span class="notification_tab_item">
              Mentions
              <badge-default
                v-if="counts.Mentions"
                :count="counts.Mentions"
                class="ml-100"
                size="is-large"
              />
            </span>
          </template>

          <notification-section
            :category="ENUMS.NotificationCategoryEnum.Mentions"
            @reset="getCounts"
          />
        </b-tab-item>

        <!-- Tasks -->
        <b-tab-item :value="ENUMS.NotificationCategoryEnum.Tasks.value.toString()">
          <template #header>
            <span class="notification_tab_item">
              Tasks
              <badge-default
                v-if="counts.Tasks"
                :count="counts.Tasks"
                class="ml-100"
                size="is-large"
              />
            </span>
          </template>

          <notification-section
            :category="ENUMS.NotificationCategoryEnum.Tasks"
            @reset="getCounts"
          />
        </b-tab-item>

        <!-- Appointments -->
        <b-tab-item :value="ENUMS.NotificationCategoryEnum.Appointments.value.toString()">
          <template #header>
            <span class="notification_tab_item">
              Appointments
              <badge-default
                v-if="counts.Appointments"
                :count="counts.Appointments"
                class="ml-100"
                size="is-large"
              />
            </span>
          </template>

          <notification-section
            :category="ENUMS.NotificationCategoryEnum.Appointments"
            @reset="getCounts"
          />
        </b-tab-item>

        <!-- Leads -->
        <b-tab-item :value="ENUMS.NotificationCategoryEnum.Leads.value.toString()">
          <template #header>
            <span class="notification_tab_item">
              Leads
              <badge-default
                v-if="counts.Leads"
                :count="counts.Leads"
                class="ml-100"
                size="is-large"
              /></span>
          </template>

          <notification-section
            :category="ENUMS.NotificationCategoryEnum.Leads"
            @reset="getCounts"
          />
        </b-tab-item>

        <!-- Comms -->
        <b-tab-item :value="ENUMS.NotificationCategoryEnum.Comms.value.toString()">
          <template #header>
            <span class="notification_tab_item">
              Comms
              <badge-default
                v-if="counts.Comms"
                :count="counts.Comms"
                class="ml-100"
                size="is-large"
              />
            </span>
          </template>

          <notification-section
            :category="ENUMS.NotificationCategoryEnum.Comms"
            @reset="getCounts"
          />
        </b-tab-item>

        <!-- Errors -->
        <b-tab-item :value="ENUMS.NotificationCategoryEnum.Errors.value.toString()">
          <template #header>
            <span class="notification_tab_item">
              Errors
              <badge-default
                v-if="counts.Errors"
                :count="counts.Errors"
                class="ml-100"
                size="is-large"
              />
            </span>
          </template>

          <notification-section
            :category="ENUMS.NotificationCategoryEnum.Errors"
            @reset="getCounts"
          />
        </b-tab-item>
      </b-tabs>
    </modal-default>
  </modal-before-container>
</template>

<script>
import NotificationItem from "./components/NotificationItem";
import {ENUMS} from "../../services/enums";
import NotificationSection from "./components/NotificationSection";
import api from "../../api";

/**
 * NOTE: Currently there are no notifications in the Profile category so it's not listed here.
 */
export default {
  name: "NotificationsModal",
  components: {NotificationSection, NotificationItem},
  data() {
    return {
      currentTab: ENUMS.NotificationCategoryEnum.Mentions.value.toString(),
      counts: {},
      intervalID: null,
      isLoaded: false,
    }
  },
  watch: {
    '$route'() {
      this.openModal();
    },
  },
  mounted() {
    this.openModal();
    this.getCounts();
  },
  methods: {
    openModal() {
      if (this.$route.query.modal === 'notifications') {
        this.$refs.NotificationsModal.open();
        this.intervalID = setInterval(() => this.getCounts(), 60000); // 1 minute
        // This isLoaded is to get Buefy to rerender the templates
        this.isLoaded = true

        // These allow us to designate which tab to have active when opening the modal
        if(this.$route.query.tab === ENUMS.NotificationCategoryEnum.Mentions.key) {
          this.currentTab = ENUMS.NotificationCategoryEnum.Mentions.value.toString()
        }
        if(this.$route.query.tab === ENUMS.NotificationCategoryEnum.Tasks.key) {
          this.currentTab = ENUMS.NotificationCategoryEnum.Tasks.value.toString()
        }
        if(this.$route.query.tab === ENUMS.NotificationCategoryEnum.Appointments.key) {
          this.currentTab = ENUMS.NotificationCategoryEnum.Appointments.value.toString()
        }
        if(this.$route.query.tab === ENUMS.NotificationCategoryEnum.Leads.key) {
          this.currentTab = ENUMS.NotificationCategoryEnum.Leads.value.toString()
        }
        if(this.$route.query.tab === ENUMS.NotificationCategoryEnum.Comms.key) {
          this.currentTab = ENUMS.NotificationCategoryEnum.Comms.value.toString()
        }
        if(this.$route.query.tab === ENUMS.NotificationCategoryEnum.Errors.key) {
          this.currentTab = ENUMS.NotificationCategoryEnum.Errors.value.toString()
        }
      }
    },
    getCounts() {
      api.notifications.counts().then((response) => {
        this.counts = response.data
      })
    },
    modalClosed() {
      clearInterval(this.intervalID)
      this.isLoaded = false
    }
  }
}
</script>

<style lang="scss" scoped>
.notification_tab_item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
</style>
